import { useMemo } from 'react';
import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
// @ts-expect-error Could not find a declaration file for module
import { GET_LESSON_AVAILABLE_LANGUAGES } from '../../queries/lessonsQuery';
import { GET_TRACK_AVAILABLE_LANGUAGES } from '../../features/tracks';
export const useAvailableLanguages = (type = 'track', id) => {
  const {
    loading,
    data,
    error
  } = useQuery(type === 'track' ? GET_TRACK_AVAILABLE_LANGUAGES : GET_LESSON_AVAILABLE_LANGUAGES, {
    variables: {
      lessonId: id,
      trackId: id
    }
  });
  const availableLanguagesData = useMemo(() => {
    if (!data) return [];
    return [...data].sort();
  }, [data]);
  return {
    availableLanguagesLoading: loading,
    availableLanguagesData,
    availableLanguagesError: error
  };
};
export const useAvailableLanguageOrFallback = ({
  trackId,
  lessonId,
  language
}) => {
  const {
    availableLanguagesData,
    availableLanguagesLoading
  } = useAvailableLanguages(trackId ? 'track' : 'lesson', trackId || lessonId);
  const languageToLoad = useMemo(() => {
    // fallback if the user requests a language that is not supported (defaults to English or the first available language)
    if (availableLanguagesData && availableLanguagesData.length && !availableLanguagesData.includes(language.toUpperCase())) {
      const lowerCasedAvailableLanguages = availableLanguagesData.map(availableLanguage => availableLanguage.toLowerCase());
      return lowerCasedAvailableLanguages.includes('en') ? 'en' : lowerCasedAvailableLanguages[0];
    }
    return language;
  }, [availableLanguagesData, language]);
  return {
    languageToLoad,
    availableLanguagesLoading
  };
};
export default useAvailableLanguages;